export const wrapper = {
    flex: 1,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
};

export const searchIcon = {
    position: 'absolute',
    left: 12,
    fontSize: 18,
    color: 'var(--ecal-lightgrey)',
    pointerEvents: 'none',
    zIndex: 1,
};

export const input = {
    width: '100%',
    background: 'rgba(0,0,0,0.30)',
    border: '1px solid rgba(255,255,255,0.10)',
    borderRadius: '12px',
    pl: '2.5rem',
    pr: '1rem',
    py: '0.9375rem',    // fix 1 — 44px → 50px height
    color: 'var(--ecal-white)',
    fontSize: '16px',   // fix 1 — was 15px (0.9375rem)
    outline: 'none',
    transition: 'border-color 0.18s ease',
    fontFamily: 'inherit',
    '&::placeholder': { color: 'var(--ecal-midgrey)' },
    '&:focus': { borderColor: 'var(--ecal-lightblue)' },
};
